// src/components/ProductTitleSection.jsx
import React from "react";

const ProductTitleSection = ({
  title,
  image,
  priceHtml,
  shortDescription,
  description,
  stockStatus,
  attributes = [],
  externalUrl,
}) => {	
	
  return (
    <section className="py-20">
      <div className="container mt-10">
	  
	  <h1 className="mb-5 text-black" style={{ fontWeight: 'bold' }}>{title}</h1>
	  
	  
        <div className="row g-5 justify-content-center justify-content-lg-between">
          <div className="col-lg-6">
            <div className="product-image text-center">
              <img src={image} alt={title} className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-6 col-xl-5">
	  
	  
<p className="text-black lead">
  {description}
</p>

	  
	  <ol className="list-group list-group-separated col-12">
	  
	  {stockStatus === "instock" ? (
		  <li className="list-group-item d-flex justify-content-between align-items-start text-black">
			<span>
			  <p className="mt-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>Price</p>
			</span>
			<p
			  className="mt-0"
			  style={{ lineHeight: "90%", textTransform: "uppercase", textAlign: "right" }}
			  dangerouslySetInnerHTML={{ __html: priceHtml }}
			/>
		  </li>
		) : (
		  <li className="list-group-item d-flex justify-content-between align-items-start text-black">
			<span>
			  <p className="mt-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>Status</p>
			</span>
			<p
			  className="mt-0"
			  style={{ lineHeight: "90%", textTransform: "uppercase", textAlign: "right" }}
			>
			  Delisted
			</p>
		  </li>
		)}


	  {attributes.map((attr) => (
       <li key={attr.id} className="list-group-item d-flex justify-content-between align-items-start text-black">
	  
		<span>
			<p className="mt-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>{attr.name}</p>
		</span>
			<p className="mt-0" style={{ lineHeight: "90%", textTransform: "uppercase", textAlign: "right" }}>
				{attr.options.join(", ")}
			</p>
		  </li>
		))}
		</ol>

            {stockStatus === "instock" && (
              <a
                href={externalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-dark col-12 mt-3 mb-3"
				style={{ textTransform: "uppercase" }}
              >
                Make It Yours
              </a>
            )}

          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductTitleSection;
